var map = {
	"./certificate-1.png": "147b",
	"./certificate-2.png": "0e00",
	"./certificate-3.png": "92b6",
	"./certificate-4.png": "9ef4",
	"./certificate-5.png": "59f3",
	"./certificate-6.png": "271c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c835";